import React from 'react'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'
import TraineeSoftwareDeveloperBody from '../components/softwareDeveloper/TraineeSoftwareDeveloperBody'

const TraineeSoftwareDeveloper = () => {
  return (
    <div>
      <Navbar></Navbar>
      <TraineeSoftwareDeveloperBody></TraineeSoftwareDeveloperBody>
      <Footer></Footer>
    </div>
  )
}

export default TraineeSoftwareDeveloper
